import * as React from 'react';
import { ContentfulCarousel, ContentfulCtaPopUp, ContentfulHeroFrame } from '../../components';
import { ContentfulMarkdownRemarkRenderer } from '../../utils';
import {
  ComponentFrameContentsMap,
  ContentfulFrameContentsPropsMap,
  ExtraContentfulContentsPropsMap,
} from '../frame-page-display';
import {
  ComponentFramesMap,
  ContentfulFramesPropsMap,
  ExtraFramesPropsMap,
} from '../frame-page-display';
import { FrameDisplay } from './frame-display';

export const CONTENTS: {
  [K in keyof ExtraContentfulContentsPropsMap]: {
    Component: ComponentFrameContentsMap[K];
    mapProps: (
      props: ContentfulFrameContentsPropsMap[K],
      extra: ExtraContentfulContentsPropsMap[K],
    ) => React.ComponentProps<ComponentFrameContentsMap[K]>;
  };
} = {
  ContentfulContent: {
    Component: ContentfulMarkdownRemarkRenderer,
    mapProps: (item, extra) => ({
      markdown: item.content,
      animation: extra?.index === 0,
      customComponentAnimation: true,
    }),
  },
  ContentfulCarousel: {
    Component: ContentfulCarousel,
    mapProps: item => ({ ...item }),
  },
  ContentfulCtaPopUp: {
    Component: ContentfulCtaPopUp,
    mapProps: item => ({ ...item }),
  },
};

export const FRAMES: {
  [K in keyof ExtraFramesPropsMap]: {
    Component: ComponentFramesMap[K];
    mapProps: (
      props: ContentfulFramesPropsMap[K],
      extra: ExtraFramesPropsMap[K],
    ) => React.ComponentProps<ComponentFramesMap[K]>;
  };
} = {
  ContentfulFrame: {
    Component: FrameDisplay,
    mapProps: (item, extra) => ({
      ...item,
      ...extra,
    }),
  },
  ContentfulHeroFrame: {
    Component: ContentfulHeroFrame,
    mapProps: item => ({ ...item }),
  },
};
